module.exports = __webpack_public_path__ + "img/maintop.e680e8b.png";